import React, { useState, useEffect, useRef } from "react";

import {
    Button,
    Dialog,
    Grid,
    Icon,
    Typography,
    Select,
    FormHelperText,
    Input,
    Tooltip,
} from "@material-ui/core";

import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";

import RichTextEditor from "react-rte";
import {
    InputBaseField,
    SelectField,
    TextareaField,
} from "../../../../../components/InputField/InputField";
import {
    Label,
    LabelNoColumn,
    DraggableComponent,
} from "../../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../../Services/APIService";
import { withSnackbar } from "../../../../../components/Message/Alert";
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";
import useStyles from "./styles";
import {
    validateEmail,
    validatePhoneNumber,
    handleNumberKeyPress,
    allowedAttachmentsForEmail,
} from "../../../../../../src/components/Common/Extensions";
import Logo from "../../../../../assets/img/Figger-foundation-logo.svg";


import PressReleaseHeader from "../../../../../assets/img/common/pressRelease.png";
import PressReleaseFooter from "../../../../../assets/img/common/pressReleaseFooter.png";

// import EmailIcon from "../../../../../assets/img/email/email2-white.png";
// import CallIcon from "../../../../../assets/img/email/call2-white.png";
// import GlobIcon from "../../../../../assets/img/email/globe2-white.png";
import FaceBookIcon from "../../../../../assets/img/email/Facebook.png";
import InstaIcon from "../../../../../assets/img/email/Instagram.png";

import linkedInIcon from "../../../../../assets/img/email/Linkedin.png";

import TwitterIcon from "../../../../../assets/img/email/Twitter.png";

import MapIcon from "../../../../../assets/img/email/map2-white.png";
import Loader from "../../../../../components/Loader/Loader";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CallIcon from '@material-ui/icons/Call';
import EmailIcon from '@material-ui/icons/Email';
import LanguageIcon from '@material-ui/icons/Language';

function ReviewRequest({ dialogOpenClose, handleClose, handleSuccessClose, accountNumber, isPrepaid, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const commonAttachments = allowedAttachmentsForEmail();
    const [emailSizeKb, setWmailSizeKb] = useState(0);
    const [state, setState] = useState({ distributionListId: 0 });
    const { showMessage } = props;
    const [distributionList, setDistributionList] = useState([]);
    const [lstLinks, setLstLinks] = useState([]);
    const [mediaList, setMediaList] = useState([]);
    const addMediaFile = useRef(null);

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const [referenceLinkList, setReferenceLinkList] = useState([]);
    let errorList = [];
    const isValidURL = (url) => {
        const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?/;
        return urlPattern.test(url);
    };
    const addRefLinks = (value) => {
    
        var isInvalid = false;
        if (!value) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorRefLinks: true,
            }));
            errorList.push(true);
            isInvalid = true;
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorRefLinks: false,
            }));
        }
        if (!isValidURL(value) && value) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorInvalidRefLinks: true,
            }));
            errorList.push(true);
            isInvalid = true;
        }
        else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorInvalidRefLinks: false,
            }));
        }
        if (!isInvalid) {
            setReferenceLinkList((prevList) => [...prevList, value]);

            setState((prevState) => {
                return { ...prevState, addRefLinks: "" };
            });
        }

    };

    const removeReferenceLink = (i) => {
        const updatedReferenceLinkList = referenceLinkList.filter(
            (item, index) => index !== i
        );
        setReferenceLinkList(updatedReferenceLinkList);

        setState((prevState) => {
            return { ...prevState, addRefLinks: "" };
        });
    };


    const [mediaFileList, setMediaFileList] = useState([]);
    //const addMedia = (file) => {
    //    if (!file) {
    //        return
    //    }
    //    let selectedFile = addMediaFile.current.files[0];
    //    setEmailSizeKb(emailSizeKb + (selectedFile.size / 1024));
    //    if (emailSizeKb >= 10000) {
    //        alert("File Size Exceeds 10 MB");
    //        return
    //    }
    //    setMediaList((prevList) => [...prevList, { file: selectedFile, fileToSend: selectedFile, fileName: selectedFile.name }]);

    //    state.addMedia = '';
    //}
    //let emailSize=0;
    const addMedia = (file) => {
        if (file == null || file.length <= 0) {
            return
        }
        const name = file[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);

        let selectedFile = addMediaFile.current.files[0];
        var selectedFileSize = (selectedFile.size / 1024);
        const previousFileSize = mediaList.reduce((total, item) => total + item.attachmentSize, 0);

        if ((selectedFileSize + previousFileSize) >= 10000) {
            alert("File Size Exceeds 10 MB");
            return
        }
        setMediaList((prevList) => [...prevList, { file: selectedFile, fileToSend: selectedFile, fileName: selectedFile.name, extension: ext, attachmentSize: selectedFileSize }]);

        state.addMedia = '';
    }
    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const isDocAlreadyExists = mediaList.filter(
            (item) => item.fileName == e.target.files[0].name
        );

        if (isDocAlreadyExists && isDocAlreadyExists.length > 0) {
            showMessage("Error", "File/Document already selected.", "error", 3000);
            return
        }

        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg .csv .xlsx .pdf .docx", "error", 3000);
                return;
        }
        addMedia(e.target.files);
    }


    const removeMedia = (i) => {
        const updatedMediaFileList = mediaList.filter((item, index) => index !== i);
        setMediaList(updatedMediaFileList);

        setState((prevState) => {
            return { ...prevState, addMedia: "" };
        });
    };

    const toolbarConfig = {
        display: [
            "INLINE_STYLE_BUTTONS",
            "BLOCK_TYPE_BUTTONS",
            "BLOCK_TYPE_DROPDOWN",
        ],
        INLINE_STYLE_BUTTONS: [
            { label: "Bold", style: "BOLD", className: "custom-css-class" },
            { label: "Italic", style: "ITALIC" },
            { label: "strikethrough", style: "STRIKETHROUGH" },
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: "UL", style: "unordered-list-item" },
            { label: "OL", style: "ordered-list-item" },
            { label: "Blockquote", style: "blockquote" },
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: "Style", style: "unstyled" },
            { label: "Heading Large", style: "header-one" },
            { label: "Heading Medium", style: "header-two" },
            { label: "Heading Small", style: "header-three" },
        ],
    };

    const [defaultTemplate, setDefaultTemplate] = useState("Select Distribution");
    const [emailTemp, setEmailTemp] = useState([]);

    const [EDITOR_CHAR_LENGTH, setEDITOR_CHAR_LENGTH] = useState(0);

    const regex = /(<([^>]+)>)/gi;
    const regexSpaces = /((&nbsp;))*/gim;

    const MAX_EDITOR_LENGTH = 2000;

    const [editorValue, setEditorValue] = useState(
        RichTextEditor.createValueFromString("", "html")
    );

    const handleEditorChange = (editorValue) => {
        const editorDetail = editorValue.toString("html").replace(regex, "");

        if (editorDetail && editorDetail.length > MAX_EDITOR_LENGTH) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorEditorMaxValue: true,
            }));
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorEditorMaxValue: false,
            }));
        }
        setEDITOR_CHAR_LENGTH(editorDetail.length);

        setEditorValue(editorValue);

        setState((prevState) => ({
            ...prevState,
            Message: editorDetail,
        }));
    };

    const [errorMessages, setErrorMessages] = useState({});
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };
    const getCurrentFormattedDate = () => {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = new Date().toLocaleDateString(undefined, options);
        return formattedDate;
    };
    const Validate = (errorList) => {
        if (!state.title) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorTitle: true,
            }));
            errorList.push(true);
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorTitle: false,
            }));
        }

        if (!state.distributionListId || state.distributionListId <= 0) {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorDistributionListId: true,
            }));
            errorList.push(true);
        } else {
            setErrorMessages((prevState) => ({
                ...prevState,
                errorDistributionListId: false,
            }));
        }

        if (!state.Message) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMessage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMessage: false
            }));
        }

    }
    const addNew = () => {

        Validate(errorList);
        if (errorList.length < 1) {
            showActionDialog("Please confirm that all content is proofread and valid. Once confirmed this press release will be distributed to all agencies in the selected distribution list.", "confirm", function () {
                setIsLoading(true);
                var method = "fdnemployeepressrelease/add";
                state.title = state.title.trim()
                if (state.scheduleDateTime) {
                    // Convert the current date to UTC
                    state.scheduleDateTime = new Date(state.scheduleDateTime).toUTCString();
                }
                const formData = new FormData();
                for (var key in state) {
                    if (state[key] && key != "fileToSend" && key != 'lstLinks' && key != 'mediaFiles' && key != 'mediaFileNames'
                        && key != "photoName"
                        && key != "encUserID"
                    )
                        formData.append(key, state[key]);
                }
                formData.append("MediaFiles", mediaList);
                formData.append("status", 'Publishing');
                formData.append("content", editorValue.toString('html'));
                for (const element of mediaList) {
                    formData.append("mediaFiles", element.fileToSend);
                    formData.append("mediaFileNames", element.fileName);
                }
                for (const element of referenceLinkList) {
                    formData.append("refrenceLinks", element);
                }
                formData.append("signalRConnectionId", sessionStorage.getItem('signalRConnectionId'));
                PostDataAPI(method, formData, true, "formData").then((result) => {
                    setIsLoading(false);
                    if (result.success) {
                        if (result.data) {
                          
                            handleSuccessClose("Publish request sent successfully");
                        }
                        else {
                            showMessage("Error", "Error sending Publish request, please contact administrator", "error", 3000);
                        }
                    }
                    else {
                        showMessage("Error", result.message, "error", 3000);

                    }

                })
            });
        }
    }


    const loadDistributionList = () => {
        setIsLoading(true);
        var params = { category: 'PR' }
        PostDataAPI("fdndistributionlist/getDistributionList", params).then((result) => {

            if (result.success && result.data) {
                // Define your default value
                const defaultValue = {
                    listId: 0,  // Set a unique value for the default item
                    listName: 'Select distribution list', // Label for the default item
                };
                // Concatenate the default value with result.data
                const dataWithDefault = [defaultValue, ...result.data];

                // Transform the data
                const transformedData = dataWithDefault.map((item) => ({
                    value: item.listId,
                    label: item.listName,
                }));
                setDistributionList(transformedData);
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    };

    useEffect(() => {
        loadDistributionList();
    }, []);
    const now = new Date();
    // Convert the current date to ISO string format
    const currentDateTime = now.toISOString().slice(0, 16);
    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props}
        >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>New Press Release</Typography>

                        <Icon
                            className={classes.closeIcon}
                            onClick={handleClose}
                            color="primary"
                        >
                            <CloseIcon />
                        </Icon>
                    </div>

                    {isLoading ? <Loader></Loader> : ""}
                    <Scrollbars autoHeight autoHeightMax={440}>
                        <div className={classes.content}>
                            <Grid container spacing={2}>
                                <Grid item sm={6} md={6} lg={6} xl={6}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label title="Title" size={50} mandatory={true} />
                                                <InputBaseField
                                                    name="title"
                                                    value={state.title}
                                                    onChange={handleChange}
                                                    placeholder="Press release title"
                                                    type="text"
                                                    MaxLength={200}
                                                />
                                                {errorMessages.errorTitle &&
                                                    (!state.title) ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please enter press release title
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row>
                                                <Label
                                                    title="Agency Distribution List"
                                                    size={12}
                                                    mandatory={true}
                                                />

                                                <SelectField
                                                    options={distributionList}
                                                    onChange={handleChange}
                                                    value={state.distributionListId}
                                                    name="distributionListId"
                                                    placeholder={"Select Distribution List"}
                                                    defaultValue={defaultTemplate}
                                                    className={classes.selectBaseInput}
                                                ></SelectField>
                                                {errorMessages.errorDistributionListId &&
                                                    (!state.distributionListId ||
                                                        state.distributionListId <= 0) ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please select agency distribution list
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} className={classes.textEditor}>
                                        <Grid item sm={12} md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Label title="Message" size={12} mandatory={true} />
                                                <RichTextEditor
                                                    name="content"
                                                    value={editorValue}
                                                    onChange={handleEditorChange}
                                                    className={classes.note}
                                                    placeholder="Message goes here..."
                                                    toolbarConfig={toolbarConfig}
                                                ></RichTextEditor>

                                                {errorMessages.errorMessage && !state.Message ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please enter a message
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} className={classes.textEditor}>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Label title="Schedule DateTime" size={12} />
                                                <InputBaseField
                                                    type="datetime-local"
                                                    name="scheduleDateTime"
                                                    id="scheduleDateTime"
                                                    value={state.scheduleDateTime}
                                                    onChange={handleChange}
                                                    allowClear={false}
                                                    minDateTime={new Date().toISOString().split('T')[0] + "T00:00"}
                                                />

                                                {errorMessages.errorScheduleDate && !state.scheduleDateTime ? (
                                                    <FormHelperText style={{ color: "red" }}>
                                                        Please enter valid schedule datetime
                                                    </FormHelperText>
                                                ) : (
                                                    ""
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>


                                    <Grid container spacing={3}>

                                        <Grid item xs={12} sm={12}  md={12} lg={12} xl={12}>
                                            <Grid row>
                                                <Grid container spacing={1}>
                                                    <Grid item sm={9} md={9} lg={9} xl={9}>
                                                        <Grid row >
                                                            <Label title="Add Media" size={12} />
                                                            <Grid row className={classes.mediaInput}>
                                                                <input type="file" ref={addMediaFile} name="addMedia" value={state.addMedia} className={classes.inputFile}
                                                                    onChange={uploadSingleFile}
                                                                    placeholder="Add Media"></input>
                                                                {errorMessages.errorAddMediaDuplicate ? (<FormHelperText style={{ color: "red" }} >
                                                                    A file with the same name already exists.
                                                                </FormHelperText>) : ('')}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    {/*<Grid item sm={3} md={3} lg={3} xl={3}>*/}
                                                    {/*    <LabelNoColumn title="" size={12} />*/}
                                                    {/*    <Button className={classes.changeBtnSm} onClick={() => addMedia(state.addMedia)}>Add Media</Button>*/}
                                                    {/*</Grid>*/}

                                                </Grid>

                                            </Grid>

                                            <Grid row>
                                                <Grid container spacing={1}>
                                                    <div className={classes.tabList}>
                                                        {mediaList
                                                            ? mediaList.map((item, i) => {
                                                                return (
                                                                    <div className={classes.tabs}>
                                                                        <button
                                                                            key={i}
                                                                            onClick={() => removeMedia(i)}
                                                                        >
                                                                            <CloseIcon className={'iconStyle'} />
                                                                        </button>

                                                                        <Tooltip title={item.fileName ? item.fileName : ""} placement="top">
                                                                            <div className={"tabText"}>
                                                                                {item.fileName ? item.fileName : ""}
                                                                            </div>
                                                                        </Tooltip>

                                                                    </div>
                                                                );
                                                            })
                                                            : ""}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3}>
                                        <Grid item sm={12} md={12} lg={12} xl={12}>
                                            <Grid container spacing={1}>
                                                <Grid item sm={9} md={9} lg={9} xl={9}>
                                                    <Grid row>
                                                        <Label title="Add Reference Links" size={12} />
                                                        <InputBaseField
                                                            name="addRefLinks"
                                                            value={state.addRefLinks}
                                                            onChange={handleChange}
                                                            placeholder="Add reference link"
                                                            type="text"
                                                        />
                                                        {errorMessages.errorRefLinks &&
                                                            (!state.addRefLinks) ? (
                                                            <FormHelperText style={{ color: "red" }}>
                                                                Please add reference link
                                                            </FormHelperText>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {errorMessages.errorInvalidRefLinks &&
                                                            (state.addRefLinks) ? (
                                                            <FormHelperText style={{ color: "red" }}>
                                                                Please add valid reference link
                                                            </FormHelperText>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item sm={3} md={3} lg={3} xl={3}>
                                                    <LabelNoColumn title="" size={12} />
                                                    <Button
                                                        className={classes.changeBtnSm}
                                                        onClick={() => addRefLinks(state.addRefLinks)}
                                                    >
                                                        Add Link
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                            <Grid row>
                                                <Grid container spacing={1}>
                                                    <div className={classes.tabList}>
                                                        {referenceLinkList
                                                            ? referenceLinkList.map((item, i) => {
                                                                return (
                                                                    <div className={classes.tabs}>
                                                                        <button
                                                                            key={i}
                                                                            onClick={() => removeReferenceLink(i)}
                                                                        >
                                                                            <CloseIcon className={'iconStyle'} />
                                                                        </button>{" "}

                                                                        <Tooltip title={item} placement="top">
                                                                            <div className={"tabText"}>
                                                                                {item}
                                                                            </div>
                                                                        </Tooltip>

                                                                    </div>
                                                                );
                                                            })
                                                            : ""}
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid
                                    item
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                //   className={classes.templateGrid}
                                >
                                    <div className={classes.templateContainer}>
                                        <div>
                                            <img width="100%" src={PressReleaseHeader} />
                                        </div>
                                        {/* <div className={"tempHeader"}>
                                            <Grid container alignItems="center">
                                                <Grid item lg={6} md={6}>
                                                    <img src={Logo} />
                                                </Grid>
                                                <Grid item lg={6} md={6} className={"textRight"}>
                                                    <h2
                                                        className={classes.paddingRight}
                                                        style={{ color: "white" }}
                                                    >
                                                        Press Release
                                                    </h2>
                                                </Grid>
                                            </Grid>
                                        </div> */}

                                        <Grid container alignItems="center">
                                            <Grid item lg={6} md={6}></Grid>
                                            <Grid item lg={6} md={6} className={"textRight"}>
                                                <h4>{getCurrentFormattedDate()}</h4>
                                            </Grid>
                                        </Grid>

                                        <div className={"tempContent"}>
                                            <h1 className="textCenter">{state.title}</h1>

                                            <Grid container>
                                                <Grid item md={12} lg={12}>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: editorValue.toString("html"),
                                                        }}
                                                    ></p>
                                                </Grid>
                                            </Grid>


                                        </div>


                                        <div>
                                            {referenceLinkList.length > 0 ? (
                                                <div>
                                                    <b>Reference Link</b>
                                                </div>
                                            ) : null}
                                        </div>

                                        <div>
                                            {referenceLinkList ? (
                                                <ul className={classes.refLinksShow}>
                                                    {referenceLinkList.map((item, i) => (
                                                        <li key={i}>
                                                            <a href={item} target="_blank">
                                                                {item}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : null}
                                        </div>


                                        <div>
                                            <p className={classes.FooterText}>
                                            The Figgers Foundation is a not-for-profit 501 (c) 3 foundation registered with the IRS and the Florida Department of Agriculture, Chapter s. 496.405, Florida Statutes for the purpose of solicitation of contributions.
                                            </p>
                                        </div>
                                        <div>
                                            <img width={"100%"} src={PressReleaseFooter} />
                                        </div>


                                        <Grid container>
                                            <Grid
                                                lg={12}
                                                md={12}
                                                sm={12}
                                            // className={classes.footerGrid}
                                            >

                                                <Grid container className={classes.templateSocial}>
                                                    <Grid item sm={4} lg={4} md={4}>
                                                        <o> <CallIcon /> 1-800-391-2803</o>
                                                    </Grid>

                                                    <Grid item sm={4} lg={4} md={4}>
                                                        <o> <EmailIcon /> Info@FiggersFoundation.org</o>
                                                    </Grid>

                                                    <Grid item sm={4} lg={4} md={4} style={{textAlign: 'right'}}>
                                                        <o> <LanguageIcon /> FiggersFoundation.org</o>
                                                    </Grid>

                                                </Grid>


                                                <div className={classes.templateFooter}>


                                                    <Grid container>
                                                        <Grid item lg={12} md={12} sm={12}>
                                                            <p> <LocationOnIcon style={{ fontSize: '18px', margin: '0 5px' }} /> 3810 Inverrary Boulevard, Suite 401 Fort Lauderdale, Florida 33319</p>
                                                        </Grid>

                                                        {/* <Grid item lg={12} md={12} sm={12}>
                                                            <div className={classes.footerLogo}>
                                                              
                                                                <a href="https://www.facebook.com/Figgers-Foundation-2265042470489249/">
                                                                    <img src={FaceBookIcon} alt="Facebook Icon" />
                                                                </a>
                                                                <a href="https://instagram.com/figgersfoundation?igshid=fhe096n05fqb">
                                                                    <img src={InstaIcon} alt="Instagram Icon" />
                                                                </a>
                                                             
                                                                <a href="https://twitter.com/Figgershelps">
                                                                    <img src={TwitterIcon} alt="Twitter Icon" />
                                                                </a>
                                                               
                                                                <a href="https://www.linkedin.com/company/the-figgers-foundation/">
                                                                    <img src={linkedInIcon} alt="LinkedIn Icon" />
                                                                </a>
                                                            </div>
                                                            
                                                        </Grid> */}

                                                    </Grid>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>
                                Close
                            </Button>
                            <Button className={classes.changeBtn} onClick={addNew}>
                                Publish
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
        </Dialog>
    );
};

export default withSnackbar(ReviewRequest);
